import React from 'react';
import { css } from 'styled-components';

import { Container, Margin, MaxWidth } from '../../common/base';
import { Grid, Col, Anchor } from '../../common/interfaces';
import Table from '../../common/components/basic/Table';
import { useTranslation } from '../../common/libs/i18n';
import BankReportsTable from '../../landing/components/BankReportsTable';

import { ReportsWrapper, ReportsTitle } from './Styled';

const K_WHITEPAPERS_DATA = ({ t, i18n }) => {
  const reports = [
    {
      title: t('landing.reports.whitepaper_1_title', 'Whitepaper'),
      date: t('landing.reports.whitepaper_1_date', 'July 2019'),
      link: t('landing.reports.whitepaper_1_url', 'https://rupiahtoken.com/whitepaper.pdf')
    }
  ];
  if (i18n.language === 'en') {
    // include chinese whitepaper if language english
    return reports.concat([
      {
        title: t('landing.reports.whitepaper_2_title', 'Whitepaper (Chinese)'),
        date: t('landing.reports.whitepaper_2_date', 'July 2019'),
        link: t(
          'landing.reports.whitepaper_2_url',
          'https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/docs/Rupiah+Token+Whitepaper+v1.0+full+(Chinese).pdf'
        )
      }
    ]);
  }
  return reports;
};

const HomeReports = () => {
  const { t, i18n } = useTranslation();
  const whitepapers = K_WHITEPAPERS_DATA({ t, i18n });
  return (
    <ReportsWrapper>
      <Container>
        <ReportsTitle>
          <Grid justify="center">
            <Col lg={6} sm={12} text="center">
              <h2 id="reports">{t('landing.reports.title', 'Whitepaper')}</h2>
            </Col>
          </Grid>
        </ReportsTitle>
        <h3>{t('landing.reports.last_whitepaper', 'Latest Whitepaper')}</h3>
        <Margin top={32}>
          <Table
            headers={['Document name', 'Date', 'Download / View']}
            data={whitepapers.map(({ title, date, link }) => [
              {
                render: () => (
                  <div
                    css={css`
                      display: flex;
                      align-items: center;
                    `}
                  >
                    <img src="/static/images/file/ic-file-p.svg" alt="File - Icon" width={24} />
                    <div
                      css={css`
                        padding-left: 48px;
                        ${MaxWidth.sm`padding-left: 15px;`}
                      `}
                    >
                      {title}
                    </div>
                  </div>
                )
              },
              {
                render: () => date
              },
              <Anchor target="_blank" rel="noreferrer noopener" href={link}>
                <b>{t('reports.item.view_file_button', 'View File')}</b>
              </Anchor>
            ])}
            tableFlexs={[3, 2, 1]}
          />
        </Margin>
        <Margin top={60}>
          <h3>{t('landing.reports.bank_reports', 'Monthly Bank Reports')}</h3>
          <Margin top={32}>
            <BankReportsTable />
          </Margin>
        </Margin>
      </Container>
    </ReportsWrapper>
  );
};

export default HomeReports;
